export function StickyScrollDirective($window, $document) {
    'ngInject';
    return {
        link: function(scope, element, attrs) {
            let isSticky = false;
            let shouldStick = false;
            let stickPoint;
            let offset = +attrs.offset || 0;
            const WINDOW = angular.element($window);
            let ogPosition = getTopOffset();
            let originalTop = element.css('top');
            let elClone;

            function getObjSize() {
                let boundingRect;
                if(isSticky) boundingRect = elClone[0].getBoundingClientRect();
                else boundingRect = element[0].getBoundingClientRect();
                return {
                    top: `${offset}px`,
                    right: `${$document[0].documentElement.clientWidth - boundingRect.right}px`,
                    left: `${boundingRect.left}px`
                };
            }

            function getTopOffset() {
                return element[0].getBoundingClientRect().top + $document[0].documentElement.scrollTop - offset;
            }
            function getScrollTop() {
                return $window.pageYOffset;
            }
            function checkStickiness() {
                if(shouldStick && !isSticky) {
                    setSticky();
                }
                if(!shouldStick && isSticky) {
                    unsetSticky();
                }
            }
            function setSticky() {
                if(element) {
                    isSticky = true;
                    elClone = element.clone(true);
                    elClone.removeAttr('sticky-scroll');
                    elClone.css('opacity', '0');
                    elClone.css('z-index', 0);
                    element.after(elClone);
                    element.css(getObjSize());
                    element.addClass('sticky');
                }
            }
            function unsetSticky() {
                isSticky = false;
                if(elClone) elClone.remove();
                element.css('top', originalTop);
                element.removeClass('sticky');
            }
            function scrollHandler() {
                shouldStick = getScrollTop() >= stickPoint;
                checkStickiness();
            }
            function resizeHandler() {
                element.css(getObjSize());
            }
            scope.$watch(function() {
                if(isSticky) return ogPosition + getScrollTop();
                ogPosition = getTopOffset();
                return ogPosition + getScrollTop();
            }, function(newVal) {

                if(newVal !== 0 && !isSticky) {
                    stickPoint = newVal;
                }
                scrollHandler();
            });
            WINDOW.on('scroll', scrollHandler);
            WINDOW.on('resize', resizeHandler);

            scope.$on('$destroy', function() {
                WINDOW.off('scroll', scrollHandler);
                WINDOW.off('resize', resizeHandler);
            });
        }
    };
}
